// removed by extract-text-webpack-plugin
module.exports = {"root":"Editor__root___3kU3i"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/Air/Editor/Editor.scss
// module id = 978
// module chunks = 0